export const DOMAIN_DOUBLE_MATERIALITY = "DOUBLE_MATERIALITY";
